import { render, staticRenderFns } from "./course-segment-form.vue?vue&type=template&id=0363425e&scoped=true"
import script from "./course-segment-form.vue?vue&type=script&lang=js"
export * from "./course-segment-form.vue?vue&type=script&lang=js"
import style0 from "./course-segment-form.vue?vue&type=style&index=0&id=0363425e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0363425e",
  null
  
)

export default component.exports